module.exports = __webpack_public_path__ + "img/mainLogin.22edd572.png";